<div class="scroll-to-top" [ngClass]="{ 'show-scrollTop': windowScrolled }">
  <button (click)="scrollToTop()" class="btn-netfone btn-scroll-to-top" id="scrollToTopButton">
    <!--    <i class="fa fa-chevron-up">  </i>-->
    <img class="chevron-arrow-img" src="../../../../assets/images/chevron-arrow-up.svg" alt="" />
  </button>
</div>
